import React from 'react';

import { OutlinedBox } from './OutlinedStyles';

const Outlined = ({ children }) => <OutlinedBox>{children}</OutlinedBox>;

export default Outlined;
